<template>
  <div class="ribbon px-8 py-16" :class="`bg-${bg}`">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    bg: {
      type: String,
      default: 'primary-tint-6',
    },
  },
});
</script>
